import React from 'react';
import '../styles/Footer.css';
// Import your logo image
import LogoImg from '../assets/images/logo_footer.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Logo Section */}
          <div className="footer-logo-section">
            <div className="footer-logo">
              <div className="logo-icon">
                <img 
                  src={LogoImg}
                  alt="MediGrow Logo" 
                  className="logo-image"
                />
                
              </div>
              <div className="logo-text">
                <div>
                  <span className="logo-medi">MEDI</span>
                  <span className="logo-grow">GROW</span>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation Links */}
          <div className="footer-nav">
            <ul className="nav-list">
              <li><a href="#privacy" className="nav-link-footer">Privacy Policy</a></li>
            </ul>
          </div>

          {/* Contact Information */}
          <div className="footer-contact">
            <div className="contact-item">
              <span className="contact-label">Contact Us</span>
              <span className="contact-value">+91 9966223931</span>
            </div>
            <div className="contact-item">
              <span className="contact-value">support@medigrowhub.com</span>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-copyright">
          <span>©2025 All Right Reserved</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;